import RAInvoiceForm from "@/apps/tatar/invoiceApp/components/InvoiceForm/RAInvoiceForm";
import { InvoiceBaseFormModel } from "@/apps/tatar/invoiceApp/components/InvoiceForm/RAInvoiceFormModel";
import InvoicePDF from "@/apps/tatar/invoiceApp/components/InvoicePDF";
import { sendInvoiceToApproval } from "@/apps/tatar/invoiceApp/components/UploadIncomingInvoice/RAUploadInvoiceEntry";
import InvoiceService from "@/apps/tatar/invoiceApp/InvoiceService";
import { Invoice } from "@/apps/tatar/invoiceApp/RAInterfaces";
import { DeclineReasonActionType } from "@/apps/tatar/invoiceConfigApp/RACInterfaces";
import FormStruct from "@/components/Form/FormStruct/FormStruct";
import { PDFHighlight } from "@/components/PDFViewer/PDFViewer";
import DebugDataComponent from "@/debug/DebugDataComponent";
import i18n from "@/i18n";
import { AssetTypes } from "@/model/AssetTypes";
import { GFPromptBlock } from "@/modules/generic-forms-impl/layout-components/LayoutComponentsImpl";
import { useState } from "react";
import { FormSpy } from "react-final-form";
import "./APTodoUploadInvoice.scss";

interface APTodoUploadInvoiceProps {
  onClose: () => void;
  invoice: Invoice;
  referenceInvoice: Invoice;
  actionType: DeclineReasonActionType;
  activityId: string;
}
const APTodoUploadInvoice = (props: APTodoUploadInvoiceProps) => {
  const [highlight, setHighlight] = useState<PDFHighlight[]>(null);
  const [initialState] = useState(
    InvoiceService.getInitialDataForInvoice(props.invoice, {
      referenceInvoice: props.referenceInvoice,
      actionType: props.actionType,
      linkedActivity: {
        assetId: props.activityId,
        assetType: AssetTypes.Activity.InvoiceFollowUp,
      },
    })
  );
  // const fileCdnData = props.invoice?.data?.invoice?.file || {};

  let title = i18n.t("ra:APTodoUploadInvoice.Title", "Rechnung hochladen");
  if (props.actionType === DeclineReasonActionType.NEED_CORRECTION) {
    title = i18n.t(
      "ra:APTodoUploadInvoice.TitleCorrection",
      "Korrekturrechnung hochladen"
    );
  }
  if (props.actionType === DeclineReasonActionType.NEED_STORNO) {
    title = i18n.t(
      "ra:APTodoUploadInvoice.TitleStorno",
      "Stornorechnung hochladen"
    );
  }
  return (
    <FormStruct
      className={`ap-todo-upload-invoice`}
      initialValues={initialState}
      onSubmit={async (values) => {
        await sendInvoiceToApproval(
          props.invoice,
          values as InvoiceBaseFormModel
        );
        // todo check if other reloads are necessary
        props.onClose();
      }}
      submitText={i18n.t(
        "ra:APTodoUploadInvoice.Submit",
        "Zur Genehmigung senden"
      )}
      title={title}
      cancelText={i18n.t("ra:APTodoUploadInvoice.Cancel", "Abbrechen")}
      onAbort={async () => {
        await InvoiceService.deleteInvoice(props.invoice);

        props.onClose();
      }}
      renderRight={(formProps) => (
        <div className="invoice-pdf padding-10">
          <InvoicePDF invoice={props.invoice} highlights={highlight} />
          <div className={`inset-shadow`} />
        </div>
      )}
      render={(formProps) => (
        <>
          <div className={`form`}>
            <GFPromptBlock />
            <RAInvoiceForm
              ignoreCompare
              disableInvoiceKindChange
              disableLinkedInvoiceChange
              form={formProps.form}
              uploadForm
              invoice={props.invoice}
              onHighlight={(highlight?: PDFHighlight | PDFHighlight[]) => {
                setHighlight(
                  Array.isArray(highlight) ? highlight : [highlight]
                );
              }}
            />

            <FormSpy
              subscription={{ values: true, errors: true }}
              render={({ values, errors }) => (
                <DebugDataComponent data={{ value: values, error: errors }} />
              )}
            />
            {/* 
            <div className="actions">
              <BFButton
                className="delete-button"
                disabled={disableEdit}
                loading={deleting}
                appearance="clear-on-white"
                onClick={() => {
                  ModalManager.confirm({
                    message: i18n.t(
                      "ra:UploadIncomingInvoice.deleteInvoiceText",
                      "Wollen Sie die Eingangsrechnung wirklich löschen?"
                    ),
                    title: i18n.t(
                      "ra:UploadIncomingInvoice.deleteInvoiceTitle",
                      "Eingangsrechnung löschen"
                    ),
                    onConfirm: () => {
                      props.onClearSelection();
                      setDeleting(true);
                      InvoiceService.deleteInvoice(props.asset)
                        .catch((err) => {
                          DataBus.emit(DataBusSubKeys.TOAST, {
                            type: "error",
                            text: i18n.t(
                              "ra:UploadIncomingInvoice.errorDeleteInvoice",
                              "Fehler beim Löschen der Rechnung"
                            ),
                          });
                        })
                        .finally(() => setDeleting(false));
                    },
                    confirmButtonText: i18n.t(
                      "ra:UploadIncomingInvoice.deleteInvoiceConfirmButton",
                      "Löschen"
                    ),
                  });
                }}
              >
                {i18n.t("Global.Buttons.Delete")}
              </BFButton>
              <div className="fill" />
              <BFButton
                disabled={disableEdit}
                appearance="primary"
                onClick={handleSubmit}
              >
                {i18n.t(
                  "ra:UploadIncomingInvoice.SendToApproval",
                  "Zur Genehmigung senden"
                )}
              </BFButton>
            </div> */}
          </div>
        </>
      )}
    />
  );
};

export default APTodoUploadInvoice;
